"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_COMPARE_VALUE = void 0;
const SORT_COMPARE_VALUE = {
  GREATER: 1,
  LESSER: -1,
  EQUAL: 0
};
exports.SORT_COMPARE_VALUE = SORT_COMPARE_VALUE;